import React, { useState } from 'react'
import { FormattedMessage } from 'react-intl'
import MarkdownMessage from '@gluedigital/markdown-message'
import ToggleSwitch from 'src/components/ToggleSwitch/ToggleSwitch'
import MapAssets from 'src/components/MapAssets/MapAssets'
import TableAssets from './TableAssets/TableAssets'
import SearchInput from 'src/components/SearchInput/SearchInput'
import { useFilteredAssets } from 'src/hooks/api'
import { useGeolocation } from 'src/hooks/geo'

import './Assets.sass'

const Assets = () => {
  const [filter, setFilter] = useState('')
  const [onlyNearby, setOnlyNearby] = useState(false)
  const [map, setMap] = useState(true)
  const loc = useGeolocation(onlyNearby)
  const filteredAssets = useFilteredAssets(filter, loc)

  const mapText = <FormattedMessage id={`assets-home.map.${map ? 'true' : 'false'}`} />
  return (
    <div id="assets-home" className={`page-content-section ${map ? 'map-mode' : ''}`} >
      <button className="only-mobile map-button" onClick={() => setMap(!map)}>{mapText}</button>
      <header className="only-desktop">
        <h1>
          <MarkdownMessage id="assets-home.title" values={{ n: filteredAssets.length }} />
        </h1>
        <section>
          <div className="only-nearby only-desktop">
            Todos
            <ToggleSwitch value={onlyNearby} onChange={setOnlyNearby} />
            Zona
          </div>
          <button onClick={() => setMap(!map)}>{mapText}</button>
        </section>
      </header>
      <div className="search-wrapper">
        <SearchInput value={filter} onChange={setFilter} />
      </div>
      {map ? <MapAssets assets={filteredAssets} center="user" /> : <TableAssets assets={filteredAssets} />}
    </div>
  )
}

export default Assets
